import { Nota } from 'portalba360';

export const state = {
    nota: new Nota()
};
export const mutations = {

};
export const getters = {

};
export const actions = {
    async getAllNotes({ state }, data) {
        try {
            let response = await state.nota.all(data);
            return response.data;
        } catch (e) {
            return console.log(e)
        }
    },
    async addNote({ state }, data) {
        try {
            let response = await state.nota.add(data);
            return response.data;
        } catch (e) {
            return console.log(e)
        }
    }
};